import React, { useState, useEffect } from "react";
import axios from 'axios';
import Card from "react-bootstrap/Card";
import Sidebar from "../components/sidebar";
import { Col, Row, Form, Button, Alert } from "react-bootstrap";

const url = "https://api.mrcirp.com/public/whatsapp";

const Updatewhatsapp = () => {
  const [users, setUsers] = useState([]);
  const [data, setData] = useState([]);
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem('loginUser');
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON);
      setUsers(user);
    }
  }, []);

  useEffect(() => {
    if (users.id) {
      axios.get(url).then(res => {
        if (res.data[0]) {
          setData(res.data[0]);
          setWhatsappNumber(res.data[0].numero || "");
        }
      });
    }
  }, [users]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrorMessage("");

    // Validate the WhatsApp number (basic validation)
    if (!whatsappNumber || whatsappNumber.length < 10) {
      setErrorMessage("Por favor ingrese un número de WhatsApp válido");
      return;
    }

    axios.put(url + '/' + users.id, { tlfwhatsapp: whatsappNumber })
      .then(response => {
        setSuccessMessage("Número de WhatsApp actualizado correctamente");
        // Update local data
        setData(prev => ({ ...prev, tlfwhatsapp: whatsappNumber }));
        console.log(response.data);
      })
      .catch(error => {
        setErrorMessage("Error al actualizar el número de WhatsApp");
        console.error("Error updating WhatsApp:", error);
      });
  };

  return (
    <div>
      <Sidebar>
        <Card>
          <Card.Header className="bg-dark text-white" as="h4">Actualizar Whatsapp CRM</Card.Header>
          <Card.Body>
            {successMessage && <Alert variant="success">{successMessage}</Alert>}
            {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group controlId="formWhatsapp" className="mb-3">
                    <Form.Label>Número de Soporte</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Ingrese su número de WhatsApp"
                      value={whatsappNumber}
                      onChange={(e) => setWhatsappNumber(e.target.value)}
                      required
                    />
                    <Form.Text className="text-muted">
                      Este número se usará para el contacto del CIRP por WhatsApp
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Button variant="primary" type="submit">
                Actualizar WhatsApp
              </Button>
            </Form>

            <hr className="my-4" />

            <Card.Title>Información del usuario</Card.Title>
            <Card.Text>
              Datos de tu cuenta en el sistema (solo lectura).
            </Card.Text>

            <Row>
              <Col xs={6} md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Codigo de usuario</Form.Label>
                  <Form.Control
                    readOnly
                    type="text"
                    value={data.id || ""}
                  />
                </Form.Group>
              </Col>
              <Col xs={6} md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    readOnly
                    type="text"
                    value={data.user || ""}
                  />
                </Form.Group>
              </Col>
              <Col xs={6} md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Nombre usuario</Form.Label>
                  <Form.Control
                    readOnly
                    type="text"
                    value={data.nombre || ""}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Sidebar>
    </div>
  );
};

export default Updatewhatsapp;